/* BD vehicle concierge — when the shopper's saved vehicle doesn't match the
   page they're on, offer the curated page for THEIR car (client ask 2026-08-25:
   Corvette-ad visitor selects their Porsche -> route them to the Porsche page).
   Modes (config from the bd-concierge snippet):
   - target page (C8 pages, make pages): banner on MISMATCH with the target
   - generic page (TOF, finder, clearance, homepage): reverse suggestion when a
     curated (non-fallback) page exists for the saved vehicle
   - pdp: banner only when the buy box reports nothing fits (bd:pdp-nofit)
   Routing: trim-level -> model-level -> make page -> TOF fallback (target pages
   only — a mismatched visitor always gets somewhere useful; reverse mode never
   suggests the fallback). Vehicle params ride along on every link. */
(async () => {
  const C = window.BDFitCore;
  const cfg = window.BD_CONCIERGE;
  const mount = document.querySelector("[data-bd-concierge]");
  if (!C || !cfg || !mount) return;
  let MAP;
  try { MAP = await (await fetch(cfg.mapUrl, { cache: "force-cache" })).json(); } catch (_) { return; }
  let pdpNoFit = !!window.__bdPdpNoFit;   // buy box may have reported before we loaded

  function resolve(saved) {
    const s = saved.slugs;
    const key = `${s.make}/${s.model}`;
    const curated = (saved.trim && MAP.trims && MAP.trims[`${key}/${saved.trim}`])
      || (MAP.models && MAP.models[key])
      || (MAP.makes && MAP.makes[s.make])
      || null;
    return { curated, url: curated || MAP.fallback || null };
  }

  const capture = (event, props) => { try { window.posthog && window.posthog.capture(event, props); } catch (_) {} };

  let lastShownFor = null;
  function render() {
    const saved = C.loadVehicle();
    mount.hidden = true; mount.innerHTML = "";
    if (!saved || !saved.slugs || !saved.vehicle) return;
    const s = saved.slugs;

    if (cfg.pdp && !pdpNoFit) return;
    let show = false;
    if (cfg.pdp) show = true;                               // buy box said nothing fits
    else if (cfg.target) show = (cfg.target.make && s.make !== cfg.target.make)
      || (cfg.target.model && s.model !== cfg.target.model); // mismatch with this page's car
    if (!cfg.pdp && !cfg.target) show = true;                // reverse mode: gated below
    if (!show) return;

    const { curated, url } = resolve(saved);
    if (!url) return;
    // reverse mode only offers genuinely curated pages, and never the page we're on
    if (!cfg.target && !cfg.pdp && !curated) return;
    if (url.split("?")[0] === location.pathname) return;

    const params = C.vehicleLinkParams();
    const href = params ? `${url}${url.includes("?") ? "&" : "?"}${params}` : url;
    const label = saved.vehicle.label;
    const text = cfg.pdp
      ? `This design doesn't fit your <b>${label}</b> — see wheels that do.`
      : cfg.target
        ? `Driving a <b>${label}</b>? We have wheels picked for it.`
        : `We have a dedicated page for your <b>${label}</b>.`;
    mount.innerHTML = `<div class="bd-concierge__inner">
      <span class="bd-concierge__text">${text}</span>
      <a class="bd-concierge__cta" data-bd-concierge-go href="${href}">See your wheels →</a>
    </div>`;
    mount.hidden = false;
    const sig = `${s.make}/${s.model}/${saved.trim || ""}/${href}`;
    if (sig !== lastShownFor) {
      lastShownFor = sig;
      capture("vehicle_mismatch", { page_target: cfg.target ? `${cfg.target.make}/${cfg.target.model || "*"}` : (cfg.pdp ? "pdp" : "none"),
        suggested_url: url, make: s.make, model: s.model, trim: saved.trim || null, curated: !!curated });
    }
    mount.querySelector("[data-bd-concierge-go]").addEventListener("click", () =>
      capture("vehicle_concierge_click", { suggested_url: url, make: s.make, model: s.model }));
  }

  window.addEventListener("bd:vehicle-changed", render);
  window.addEventListener("bd:pdp-nofit", (e) => { pdpNoFit = !!(e.detail && e.detail.nofit); render(); });
  render();
})();
